import { CollectionItem, Collection, Coordinates } from 'mytours-read-common'

import { setDataToLocalStorage, getDataFromLocalStorage, removeDataFromLocalStorage } from '../platform'

export function saveCollectionItemsToDisk(
	projectId: string,
	collectionId: number,
	collectionVersion: number,
	language: string,
	items: CollectionItem[] | undefined,
): Promise<void> {
	const key = projectId + '_collection_' + collectionId + '_' + language + '_' + collectionVersion
	return setDataToLocalStorage(key, items)
}

/**
 * Attempts to load collection items from disk. Parses into CollectionItem[] type.
 */
export function loadCollectionItemsFromDisk(
	projectId: string,
	collectionId: number,
	collectionVersion: number,
	language: string,
): Promise<CollectionItem[] | undefined> {
	const key = projectId + '_collection_' + collectionId + '_' + language + '_' + (collectionVersion || '')
	return getDataFromLocalStorage(key, false, !collectionVersion)
}

/**
 * Removes any collection items that are persisted on disk.
 */
export function removeCollectionItemsFromDisk(
	projectId: string,
	collectionId: number,
	language: string,
): Promise<void> {
	const key = projectId + '_collection_' + collectionId + '_' + language + '_'
	return removeDataFromLocalStorage(key)
}

/**
 * Saves collection details to disk so can be loaded faster next time without hitting network.
 *
 * @param collection details to save to disk.
 */
export function saveCollectionDetailsToDisk(
	projectId: string,
	collectionId: number,
	collectionVersion: number,
	language: string,
	collection: Collection,
): Promise<void> {
	const key = projectId + '_collection_details_' + collectionId + '_' + language + '_' + collectionVersion
	return setDataToLocalStorage(key, collection)
}

/**
 * Attempts to load collection details from disk. Parses into Collection type.
 */
export function loadCollectionDetailsFromDisk(
	projectId: string,
	collectionId: number,
	collectionVersion: number,
	language: string,
): Promise<Collection | undefined> {
	const key = projectId + '_collection_details_' + collectionId + '_' + language + '_' + (collectionVersion || '')
	return getDataFromLocalStorage(key, false, !collectionVersion)
}

/**
 * Removes any collection details that are persisted on disk.
 */
export function removeCollectionDetailsFromDisk(
	projectId: string,
	collectionId: number,
	language: string,
): Promise<void> {
	const key = projectId + '_collection_details_' + collectionId + '_' + language + '_'
	return removeDataFromLocalStorage(key)
}

/**
 * Saves map route to disk so can be loaded faster next time without hitting network.
 */
export function saveMapRouteToDisk(
	projectId: string,
	mapRouteId: number,
	mapRouteVersion: number,
	language: string,
	mapRoute: any[],
): Promise<void> {
	const key = projectId + '_map_route_' + mapRouteId + '_' + language + '_' + mapRouteVersion
	return setDataToLocalStorage(key, mapRoute)
}

/**
 * Attempts to load map route from disk. Parses into MapRoute type.
 */
export function loadMapRouteFromDisk(
	projectId: string,
	mapRouteId: number,
	mapRouteVersion: number,
	language: string,
): Promise<any | undefined> {
	const key = projectId + '_map_route_' + mapRouteId + '_' + language + '_' + mapRouteVersion
	return getDataFromLocalStorage(key)
}

/**
 * Removes any map route that are persisted on disk.
 */
export function removeMapRouteFromDisk(projectId: string, mapRouteId: number, language: string): Promise<void> {
	const key = projectId + '_map_route_' + mapRouteId + '_' + language + '_'
	return removeDataFromLocalStorage(key)
}

// copied this code from react-navigation-collapsible
export function getStatusBarHeight() {
	return 0
}

export const getUserCurrentPosition = (
	successCallback: (position: Coordinates) => void,
	errorCallback?: (error: { code: number; message: string }) => void,
): void =>
	navigator.geolocation.getCurrentPosition(
		successResult => {
			console.log('successResult', successResult)
			successCallback(successResult.coords)
		},
		error => {
			console.warn('get current position error', error)
			errorCallback?.(error)
		},
		{
			enableHighAccuracy: true,
			timeout: 10000,
		},
	)
